module.exports = __webpack_public_path__ + "img/england.2cac5ecb.svg";